import TopSpace from "../../components/TopSpace";
import BannerShort from "../../components/banners/BannerShort";
import Testimonial from "../../components/testimonials/Testimonial";

const Reviews = () => {

    const reviewData = {
        heading:"Take a look at our reviews",
        description:"Every day, we hear fantastic feedback from our customers, and we are grateful for all of them. You can read some of our customers’ reviews for us on our website.",
        show_view_more:false,
        view_more:{
            icon:'',
            icon_postion:"right",
            button_label:"View All",
            button_link:"/reviews",
            target:"_self"
        },
        reviews:[
            {
                id:1,
                reviewer:"Joe Doe",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nam impedit repellat hic. Fugiat nam adipisci est veritatis quo impedit, sed inventore et cumque, neque quos, quis atque recusandae soluta vel. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nam impedit repellat hic. Fugiat nam adipisci est veritatis quo impedit, sed inventore et cumque, neque quos, quis atque recusandae soluta vel. Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nam impedit repellat hic. Fugiat nam adipisci est veritatis quo impedit, sed inventore et cumque, neque quos, quis atque recusandae soluta vel."
            },
            {
                id:2,
                reviewer:"Jone Adu",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like)."
            },
            {
                id:3,
                reviewer:"H. Rackham.",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"The standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from 'de Finibus Bonorum et Malorum' by Cicero are also reproduced in their exact original form, accompanied by English versions from the 1914 translation by H. Rackham."
            },
            {
                id:4,
                reviewer:"J. Knight",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo."
            },
            {
                id:5,
                reviewer:"Sara Jone",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga."
            },   
            {
                id:6,
                reviewer:"Matt Pot",
                star:"5-Star",       
                company_name:"Managing Director @ dummytesting Ltd.",
                star_number:5,
                datetime:"",
                review:"At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga."
            },            
        ]
    };

    return (
        <TopSpace>
             <BannerShort
                heading={'Our Reviews'}
                description={'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.'}
                bgImage={'/banner/review-banner.jpg'}
            />

            <Testimonial 
                testimonial={reviewData}
            />
            
        </TopSpace>
    );
};

export default Reviews;